<template>
  
  <div id="intro_text" class="min-vh-100">
        <div class="position-absolute texture">
          <SVGQuote v-if="$i18n.locale == 'en'"></SVGQuote>
          <SVGQuoteFr v-else class="flip"></SVGQuoteFr>
        </div>
        <div v-if="items" class="container">
            <div v-for="i in items" :key="i.id">
                <div v-if="i.type == 'call_to_action'" class="row justify-content-end">
                  <div class="col-10">
                    <h2 class="explainer1 mt-5">
                      <span :class="'head-' + index" v-for="(h, index) in splitHeader" :key="index" v-html="h">.</span>
                    </h2>
                  </div>
                </div>
                <div class="row justify-content-end">
                    <div v-if="i.type == 'definition'" class="my-5 col-7 col-sm-4">
                        <p class="explainer2" v-html="$t(iKey('intro_section', i, 'text'))"></p>
                    </div>
                    <div v-if="i.type == 'definition'" class="col-3">
                        <span v-if="$i18n.locale == 'en'" aria-hidden="true" class="giant">U</span>
                        <span v-else aria-hidden="true" class="giant">D</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="position-absolute pink-band"></div>
    </div>
  
</template>

<script>
import SVGQuote from '@/assets/icons/quote.svg'
import SVGQuoteFr from '@/assets/icons/quote-fr.svg'

export default {
  name: 'IntroText',
  components: {
    SVGQuote,
    SVGQuoteFr
  },
  props: [
    'items',
  ],
  computed: {
    splitHeader(){
      var str = this.$t(this.iKey('intro_section', 'call_to_action', 'text'))
      if (str[str.length-1] === ".") {
        str = str.slice(0,-1);
      }
      return str.split('.')
    }
  },
  mounted(){
  //   var dur = this.windowHeight * 2
  //   const scene = this.$scrollmagic.scene({
  //       triggerElement: '#intro_text',
  //       triggerHook: 0,
  //       duration: dur,
  //       reverse: true
  //   })
  //   this.$scrollmagic.addScene(
  //     scene
  //       .setPin('#intro_text')
  //       //.addIndicators()
  //   )  
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#intro_text {
  overflow-x: hidden;
  position: relative;
}
.texture {
  top: 50px;
  left: 20px;
  background-image: url('../../assets/images/photocopy-texture.jpg');
  background-size: 147px 395px;
  height: 395px;
  width: 147px;
  z-index: 0;
}
.texture svg {
  position: absolute;
  left: 100px;
  top: 70px;
}
.container {
  position: relative;
  z-index: 1;
}
h2.explainer1 span {
  color: white;
  background-color: #ad841f;
  display: inline-block;
  margin-bottom: 30px;
  box-decoration-break: clone;
  padding: 0 10px;
}
.head-0 {
  transform: rotate(-3deg);
  margin-bottom: 50px !important;
}
.head-1 {
  transform: rotate(3deg);
}
.pink-band {
  width: 100%;
  height: 30%;
  background-color: #f2aeff;
  bottom: 0;
}

</style>
